import clsx from 'clsx';
import { Outlet } from 'react-router-dom';

import ErrorBoundary from '../components/Core/ErrorBoundary';
import Header from '../components/Core/Header';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';
import TransferProgressDrawers from '../components/Common/TransferProgressDrawers';

function ExternalLayout() {
  return (
    <>
      <div className="flex-grow-1 flex h-full w-full overflow-hidden bg-white">
        <Header />
        <main
          className={clsx(
            'mt-14 w-[100vw] flex-1 flex-shrink overflow-x-hidden transition-all duration-300'
          )}
        >
          <div className="h-full overflow-auto">
            <ErrorBoundary>
              <OverlayScrollbarsComponent
                options={{
                  scrollbars: {
                    autoHide: 'leave',
                  },
                }}
                defer
                style={{ height: '100%', overflow: 'auto' }}
              >
                <Outlet />
              </OverlayScrollbarsComponent>
            </ErrorBoundary>
          </div>
        </main>
        <TransferProgressDrawers />
      </div>
    </>
  );
}

export default ExternalLayout;
